import { Directive } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[baseFilterItem]',
    standalone: false
})
export class BaseFilterItemDirective {}
